import apiFetch from '@wordpress/api-fetch'
import {THEME_LANG_DOMAIN} from "../../admin/appointment/js/constants";
import { __ } from '@wordpress/i18n'

const initForm = (container) => {
    const submitButton = container.querySelector('button[type="submit"]')
    const form = container.querySelector('form')

    if (!submitButton || !form) {
        return false;
    }

    const inputs = Array.from(form.querySelectorAll('input, select'))

    const disableForm = () => {
        submitButton.classList.add('disabled')
        inputs.forEach(input => input.setAttribute('disabled', 'disabled'))
    }

    const enableForm = () => {
        submitButton.classList.remove('disabled')
        inputs.forEach(input => input.removeAttribute('disabled'))
    }

    const getData = () => inputs.map(input => {
        const match = input.getAttribute('name')?.match(/booking\[(.+)\]/)

        if (!match) {
            return null
        }

        const key = match[1]

        if (input.tagName.toLowerCase() === 'input' && (input.getAttribute('type') || 'text').toLowerCase() === 'checkbox') {
            return {
                key,
                value: input.checked ? 1 : 0
            }
        } else {
            return {
                key,
                value: input.value
            }
        }
    })
        .filter(val => !!val)
        .reduce((res, item) => {
            res[item.key] = item.value
            return res
        }, {})

    form.addEventListener('submit', (e) => {
        e.preventDefault()

        ;(async () => {
            const data = {
                booking: getData()
            }

            if (!data.booking.appointment) {
                alert('Bitte wählen Sie die gewünschte Uhrzeit aus')
                return
            }

            disableForm()

            const res = await apiFetch({ path: 'apothekehart/v1/booking-form', method: 'POST', data })

            enableForm()

            if (typeof res.error !== 'undefined') {
                alert(__('Leider ist ein Fehler aufgetreten, bitte Versuchen Sie es noch einmal.', THEME_LANG_DOMAIN))
                return
            }

            container.classList.add('success')
        })()
    })
    return true
}

export const handleForm = () => {
    const btn = document.getElementById('btn-show-booking-form')
    const container = document.getElementById('booking-form')

    if (btn && container) {
        if (initForm(container)) {
            btn.addEventListener('click', () => {
                container.classList.add('shown')
            })
        }
    }
}
